import estherHeadshot from "@/assets/esther-headshot.jpg";
import teamMember2 from "@/assets/team-member-2.jpg";

export interface TeamSocialLink {
  label: string;
  href: string;
}

export interface TeamMember {
  id: string;
  name: string;
  slug: string;
  title: string;
  email: string;
  phone: string;
  image: string;
  imageAlt: string;
  profileUrl: string;
  socialLinks: TeamSocialLink[];
  specialties: string[];
  areaServed: string[];
  featured: boolean;
  displayOrder: number;
}

export const teamMembers: TeamMember[] = [
  {
    id: "esther-summersett",
    name: "Esther Summersett",
    slug: "esther-summersett",
    title: "Broker-Owner, Realtor & Interior Designer",
    email: "Esther@hadassahhomesinc.com",
    phone: "(781) 309-2010",
    image: estherHeadshot,
    imageAlt: "Esther Summersett, Broker-Owner at Hadassah Homes",
    profileUrl: "/team/esther-summersett",
    socialLinks: [
      { label: "Facebook", href: "https://www.facebook.com/esthersummersett" },
      { label: "Instagram", href: "https://www.instagram.com/esthersummersettbroker/" },
    ],
    specialties: [
      "Massachusetts real estate",
      "Dominican Republic real estate education",
      "Interior design",
      "Property preparation",
      "Home selling strategy",
    ],
    areaServed: ["Massachusetts", "Dominican Republic"],
    featured: true,
    displayOrder: 1,
  },
  {
    id: "jessiree-pena",
    name: "Jessiree Peña",
    slug: "jessiree-pena",
    title: "Realtor",
    email: "jessi@hadassahhomesinc.com",
    phone: "(781) 521-7670",
    image: teamMember2,
    imageAlt: "Jessiree Peña, Realtor at Hadassah Homes",
    profileUrl: "/team/jessiree-pena",
    socialLinks: [
      { label: "Instagram", href: "https://www.instagram.com/realestatewithjessi/" },
    ],
    specialties: [
      "Massachusetts real estate",
      "Buyer representation",
      "Seller representation",
    ],
    areaServed: ["Massachusetts"],
    featured: true,
    displayOrder: 2,
  },
].sort((a, b) => a.displayOrder - b.displayOrder);

export const featuredTeamMembers = teamMembers.filter((member) => member.featured);
